<template>
  <register/>
</template>

<script>
import Register from '../../components/Register'

export default {
  components: {
    Register
  }
}
</script>
